import React, { useState, createContext, useEffect } from 'react'

import Notification from 'components/Notification'

type NotificationContextType = {
  showNotification: (notification: string) => void
}

export const NotificationContext = createContext({} as NotificationContextType)

const MS_UNTIL_AUTO_CLOSE = 3000

type Props = { children: React.ReactNode }

export function NotificationProvider({ children }: Props) {
  const [notification, setNotification] = useState<string | null>()

  useEffect(() => {
    if (notification) {
      setTimeout(() => setNotification(null), MS_UNTIL_AUTO_CLOSE)
    }
  }, [notification])

  return (
    <NotificationContext.Provider value={{ showNotification: setNotification }}>
      {notification && <Notification>{notification}</Notification>}

      {children}
    </NotificationContext.Provider>
  )
}
